// export const DOMEN = 'https://hotelmanager.vstrecha.com.ru/backend';
// export const DOMEN = 'http://192.168.0.150';
export const DOMEN = 'https://desktopreact.site';
export const PATH_FRONT = '/wp-content/include-me/hotel_man_web';
export const PATH_BASE = '/wp-content/include-me/HotelManagement';
export const DOMEN_BASE = DOMEN + PATH_BASE;

